export const rupiah = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp 0";
  const rounded = Math.round(Number(n));
  return "Rp " + rounded.toLocaleString("id-ID");
};

export const num = (n) => (Number(n || 0)).toLocaleString("id-ID");

// Konversi stok satuan dasar → kemasan, mis. 830 PCS dengan DUS=6 → "138 DUS + 2 PCS"
export const packDisplay = (qty, unit, packs = []) => {
  if (!packs.length || !qty) return null;
  const pk = packs[0];
  const q = Math.abs(Number(qty));
  const whole = Math.floor(q / pk.factor);
  const rest = q % pk.factor;
  if (whole === 0) return null;
  return rest === 0
    ? `= ${whole.toLocaleString("id-ID")} ${pk.unit}`
    : `= ${whole.toLocaleString("id-ID")} ${pk.unit} + ${rest.toLocaleString("id-ID")} ${unit}`;
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
